<template>
  <section class="container stand-alone-accountability" v-if="user">
    <div class="row">
      <div class="col-xs-12 col-md-9">
        <v-heading :level="3">Machtiging toevoegen</v-heading>
      </div>
      <div class="col-md-3 grid-align-end">
        <v-button link @click.native="openForwardModal"> <v-forward-icon class="icon-color-teal"></v-forward-icon>Doorsturen naar collega</v-button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <v-heading :level="4">{{licenseWithTreatmentAreaName}}</v-heading>
      </div>
    </div>
    <table class="table" id="step1">
      <colgroup>
        <col v-for="n in 1" :key="n" :class="'table-col-' + n++">
      </colgroup>
      <thead class="head">
        <tr>
          <th>Machtiging gegevens</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <!--WLZ QUESTION -->
            <div class="mb" v-if="isWLZ">
              <legend class="bold">Deze patiënt heeft een WLZ-indicatie. Stuur de rekening naar de volgende instelling:</legend>
              <basic-select
               placeholder="Zoek op Instelling, plaats of postcode"
                :options="WLZList"
                :selected-option="WLZItem"
               @select="onSelect">
              </basic-select>
            </div>
            <!--ZVZ QUESTION -->
            <div class="mb" v-if="isZVZ">
              <legend class="bold">De gekozen medische hulpmiddelen en/of medicatie kunnen niet direct naar de zorgverzekering van de patiënt worden gedeclareerd door Mediq. Stuur de factuur naar de volgende instelling:</legend>
              <basic-select
               placeholder="Zoek op Instelling, plaats of postcode"
                :options="ZVZList"
                :selected-option="ZVZItem"
               @select="onSelectZVZ">
              </basic-select>
            </div>

            <div v-if="(isWLZ && WLZArg.WLZId) || !isWLZ" name="card-animation" is="transition-group">
              <fieldset v-for="(question, indexquestion) in questions" :key="indexquestion" :data-index="indexquestion">
                <legend v-if="question.QuestionId != '1000'">{{question.Tekst}}</legend>
                <p v-if="question.Opmerking.length">{{question.Opmerking}}</p>
                <div v-for="(answer, index) in question.Antwoorden" :key="index" :data-index="index">
                  <!--STANDARD (RADIO) QUESTION-->
                  <div class="form-group__radio" v-if="answer.TypeCode === 'Standard'">
                    <input :id="answer.AnswerId" :checked="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId" @change="checkRadioAnswer" :name="question.AccountabilityLineId" type="radio" />
                    <label :for="answer.AnswerId"><span><span></span></span>{{answer.AntwoordTekst}}</label>
                  </div>
                  <!--STANDARD (RADIO) QUESTION WITH OPEN (TextInput) -->
                  <div v-if="answer.TypeCode === 'OpenStandaard'">
                    <div class="form-group__radio" >
                      <input :id="answer.AnswerId" :checked="checkRadioStatus(question.ResultaatAnswers, answer.AnswerId, question.AccountabilityLineId)" @change="checkedRadioAnswerStandard(answer.AnswerId, question.AccountabilityLineId)" :name="question.AccountabilityLineId" type="radio" />
                      <label :for="answer.AnswerId"><span><span></span></span>{{answer.AntwoordTekst}}</label>
                    </div>
                    <form @submit="submitTypeQuestionOpen" class="openquestion" :id="'form' + question.AccountabilityLineId" style="display: none" :name="question.AccountabilityLineId">
                      <div class="row">
                        <div class="col-xs-12 col-md-8">
                          <div v-if="question.ResultaatAnswers.length > 0">
                            <v-input-group-simple @input="input" type="text" v-on:input="ChangeRadioText($event, question.ResultaatAnswers[0].Resultaat, question.AccountabilityLineId)" :inputid="answer.AnswerId + 'txt'" :initvalue="question.ResultaatAnswers[0].Resultaat" sm alt></v-input-group-simple>
                          </div>
                          <div v-else>
                            <v-input-group-simple @input="input" type="text" :inputid="answer.AnswerId + 'txt'" sm alt></v-input-group-simple>
                          </div>
                          <div class="details" :id="'div' + question.AccountabilityLineId" style="display: none">
                              <div class="stand-alone-accountability__error">Het is verplicht dit veld in te vullen en op de knop 'Ga verder' te klikken.</div>
                          </div>
                        </div>
                        <div class="col-xs-12 col-md-4">
                          <div v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerTypeId === '268'">
                            <div v-if="currentRadioAnswerId === answer.AnswerId && isRadioTextChanged === true">
                              <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow :disabled="getNextRadioButtonStatus(answer.AnswerId)">Ga verder</v-button>
                            </div>
                            <div v-else>
                              <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow>Opgeslagen</v-button>
                            </div>
                          </div>
                          <div v-else>
                            <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow :disabled="getNextRadioButtonStatus(answer.AnswerId)">Ga verder</v-button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <!--DROPDOWN QUESTION -->
                  <v-select-group v-if="answer.TypeCode === 'Dropdown'"
                  label="Maak een keuze"
                  :selectid="question.AccountabilityLineId.toString()"
                  :data-answerid="answer.AnswerId"
                  :initselected="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerListItemId"
                  @change="checkSelectAnswer"
                  >
                    <option v-for="(option, indexoptions) in answer.AntwoordLijst" :key="indexoptions" :data-index="indexoptions" :initvalue="option.AnswerListItemId" :value="option.AnswerListItemId" :data-answerid="answer.AnswerId">{{option.Omschrijving}}</option>
                  </v-select-group>
                  <!--OPEN (TextInput) QUESTION -->
                  <form @submit="submitTypeQuestionOpen" v-if="answer.TypeCode === 'Open'" :name="question.AccountabilityLineId">
                    <div class="row">
                      <div class="col-md-6">
                        <div v-if="question.ResultaatAnswers.length > 0">
                          <v-input-group-simple @input="input" type="text" v-on:input="ChangeText($event, question.ResultaatAnswers[0].Resultaat, question.AccountabilityLineId)" :inputid="answer.AnswerId" :initvalue="question.ResultaatAnswers[0].Resultaat" sm alt></v-input-group-simple>
                        </div>
                        <div v-else>
                          <v-input-group-simple @input="input" type="text" :inputid="answer.AnswerId" sm alt></v-input-group-simple>
                        </div>
                        <div class="details" :id="'div' + question.AccountabilityLineId" style="display: none">
                            <div class="stand-alone-accountability__error">Het is verplicht dit veld in te vullen en op de knop 'Ga verder' te klikken.</div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div v-if="question.ResultaatAnswers.length > 0">
                          <div v-if="currentAnswerId === answer.AnswerId && isTextChanged === true">
                            <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow :disabled="getNextButtonStatus(answer.AnswerId)">Ga verder</v-button>
                          </div>
                          <div v-else>
                            <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow>Opgeslagen</v-button>
                          </div>
                        </div>
                        <div v-else>
                          <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow :disabled="getNextButtonStatus(answer.AnswerId)">Ga verder</v-button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <!--CHECKBOX QUESTION and also handle text box also-->
                  <form @submit="submitCheckbox($event, answer)" v-if="answer.TypeCode === 'Checkbox' || answer.TypeCode === 'CheckboxWithTextbox'" :name="question.AccountabilityLineId">
                    <div class="row margin-bottom" v-for="(checkbox, index) in answer.AntwoordLijst" :key="index">
                      <div class="col-md-4">
                        <v-checkbox-group
                          :label="checkbox.Omschrijving"
                          :inputid="checkbox.AnswerListItemId"
                          :initvalue="getCheckboxStatus(question.ResultaatAnswers, checkbox, answer)"
                          :overwriteValue="checkbox.IsOpen"
                          :name="answer.AnswerId"
                          @input="change(...arguments, checkbox, answer.AnswerId, answer.TypeCode)"
                          >
                        </v-checkbox-group>
                      </div>
                      <!-- Text box option for each checkbox option-->
                      <div class="col-md-6 openquestion" :id="'form' + checkbox.AnswerListItemId" :name="question.AccountabilityLineId" style="display: none">
                        <div v-if="question.ResultaatAnswers.length > 0 && checkCheckBoxTextAns(question.ResultaatAnswers, checkbox.AnswerListItemId, 'status')">
                          <v-input-group-simple :placeholder="checkbox.Placeholder" @input="inputCheckBox(...arguments, answer.AnswerId)" type="text" :inputid="'text' + checkbox.AnswerListItemId" :initvalue="checkCheckBoxTextAns(question.ResultaatAnswers, checkbox.AnswerListItemId, 'value')" sm alt></v-input-group-simple>
                        </div>
                        <div v-else>
                          <v-input-group-simple :placeholder="checkbox.Placeholder" @input="inputCheckBox(...arguments, answer.AnswerId)" type="text" :inputid="'text' + checkbox.AnswerListItemId" sm alt></v-input-group-simple>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12 remark hide-msg" :id="'remark-' + question.AccountabilityLineId" >*Selecteer ten minste één antwoord.</div>
                      <div class="col-xs-3">
                        <v-button type="submit" :id="answer.AnswerId + 'btn'" md hollow >Volgende vraag</v-button>
                      </div>
                    </div>
                  </form>
                  <!--DATE QUESTION-->
                  <div class="form-group__date" v-if="answer.TypeCode === 'Date'">
                    <v-input-date-picker
                      ref="date"
                      type="date"
                      name="dateQuestion"
                      :id="answer.AnswerId"
                      :customKey="question.AccountabilityLineId"
                      autofocus
                      :emptyDate="!getDateValue(question.ResultaatAnswers, 'Resultaat')"
                      @selected="handleDateAnswer"
                      :value="getDateValue(question.ResultaatAnswers, 'Resultaat')"
                    >
                    </v-input-date-picker>
                  </div>
                  <!-- PersonalAccountabilityProductGroup2 QUESTION-->
                  <form @submit="submitPersonalAccountabilityProductGroup2($event)" v-if="answer.TypeCode === 'PersonalAccountabilityProductGroup2'" :name="question.AccountabilityLineId" :id="answer.AnswerId">
                    <div class="row grid-margin grid-padding">
                      <div class="col-md-3 stand-alone-accountability__categoryLabel">
                        Productgroep
                      </div>
                      <div class="col-md-6">
                        <v-select-group v-if="answer.ProductGroupList && answer.ProductGroupList.length > 0"
                          label="Maak een keuze"
                          :selectid="'selectProduct-' + question.AccountabilityLineId"
                          :data-answerid="answer.AnswerId"
                          :initselected="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].ProductGroup.length > 0 &&
                          question.ResultaatAnswers[0].ProductGroup[0].ProductGroupId"
                          >
                          <option v-for="(option, indexoptions) in answer.ProductGroupList" :key="indexoptions" :data-index="indexoptions" :initvalue="option.ProductGroupId" :value="option.ProductGroupId" :data-answerid="answer.AnswerId">{{option.Name}}</option>
                        </v-select-group>
                      </div>
                    </div>
                    <div class="row grid-margin grid-padding">
                      <div class="col-md-3 stand-alone-accountability__categoryLabel">
                        Aantal stuks extra per periode
                      </div>
                      <div class="col-md-6 groupText">
                        <div v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId">
                          <v-input-group-simple type="number" :inputid="'Aantal-' + question.AccountabilityLineId.toString()" :initvalue="question.ResultaatAnswers[0].Aantal " sm alt></v-input-group-simple>
                        </div>
                        <div v-else>
                          <v-input-group-simple type="number" :inputid="'Aantal-' + question.AccountabilityLineId.toString()" sm alt></v-input-group-simple>
                        </div>
                      </div>
                    </div>
                    <div class="row grid-margin grid-padding">
                      <div class="col-md-3 stand-alone-accountability__categoryLabel">
                        Periode
                      </div>
                      <div class="col-md-6">
                        <v-select-group v-if="answer.PeriodList && answer.PeriodList.length > 0"
                          label="Maak een keuze"
                          :selectid="'selectPeriod-' + question.AccountabilityLineId.toString()"
                          :data-answerid="answer.AnswerId"
                          :initselected="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].Period.length > 0 &&
                          question.ResultaatAnswers[0].Period[0].PeriodId"
                          >
                          <option v-for="(option, indexoptions) in answer.PeriodList" :key="indexoptions" :data-index="indexoptions" :initvalue="option.PeriodId" :value="option.PeriodId" :data-answerid="answer.AnswerId">{{option.Description}}</option>
                        </v-select-group>
                      </div>
                    </div>
                    <div class="row grid-margin grid-padding">
                      <div class="col-xs-12 remark hide-msg" :id="'remark-' + question.AccountabilityLineId" >*Gelieve alle velden in te vullen.</div>
                      <div class="col-xs-4">
                        <v-button type="submit" lg hollow >Volgende vraag</v-button>
                      </div>
                    </div>
                  </form>
                  <!-- PersonalAccountabilityProductGroup3 QUESTION-->
                  <form @submit="submitPersonalAccountabilityProductGroup3($event)" v-if="answer.TypeCode === 'PersonalAccountabilityProductGroup3'" :name="question.AccountabilityLineId" :id="answer.AnswerId">
                    <div class="row grid-margin grid-padding">
                      <div class="col-md-3 stand-alone-accountability__categoryLabel">
                        Productgroep
                      </div>
                      <div class="col-md-6">
                        <v-select-group v-if="answer.ProductGroupList && answer.ProductGroupList.length > 0"
                          label="Maak een keuze"
                          :selectid="'selectProduct-' + question.AccountabilityLineId"
                          :data-answerid="answer.AnswerId"
                          :initselected="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].ProductGroup.length > 0 &&
                          question.ResultaatAnswers[0].ProductGroup[0].ProductGroupId"
                          >
                          <option v-for="(option, indexoptions) in answer.ProductGroupList" :key="indexoptions" :data-index="indexoptions" :initvalue="option.ProductGroupId" :value="option.ProductGroupId" :data-answerid="answer.AnswerId">{{option.Name}}</option>
                        </v-select-group>
                      </div>
                    </div>
                    <div class="row grid-margin grid-padding">
                      <div class="col-md-3 stand-alone-accountability__categoryLabel">
                        Aantal stuks extra per periode
                      </div>
                      <div class="col-md-6 groupText">
                        <div v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId">
                          <v-input-group-simple type="number" :inputid="'Aantal-' + question.AccountabilityLineId.toString()" :initvalue="question.ResultaatAnswers[0].Aantal.toString() " sm alt></v-input-group-simple>
                        </div>
                        <div v-else>
                          <v-input-group-simple type="number" :inputid="'Aantal-' + question.AccountabilityLineId.toString()" sm alt></v-input-group-simple>
                        </div>
                      </div>
                    </div>
                    <div class="row grid-margin grid-padding">
                      <div class="col-md-3 stand-alone-accountability__categoryLabel">
                        Periode
                      </div>
                      <div class="col-md-6">
                        <v-select-group v-if="answer.PeriodList && answer.PeriodList.length > 0"
                          label="Maak een keuze"
                          :selectid="'selectPeriod-' + question.AccountabilityLineId.toString()"
                          :data-answerid="answer.AnswerId"
                          :initselected="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].Period.length > 0 &&
                          question.ResultaatAnswers[0].Period[0].PeriodId"
                          >
                          <option v-for="(option, indexoptions) in answer.PeriodList" :key="indexoptions" :data-index="indexoptions" :initvalue="option.PeriodId" :value="option.PeriodId" :data-answerid="answer.AnswerId">{{option.Description}}</option>
                        </v-select-group>
                      </div>
                    </div>
                    <div class="row grid-margin grid-padding">
                      <div class="col-md-3 stand-alone-accountability__categoryLabel">
                        Startdatum
                      </div>
                      <div class="col-md-6">
                        <div class="form-group__date">
                          <v-input-date-picker
                            ref="date"
                            type="date"
                            :name="'startDate-' + question.AccountabilityLineId"
                            :id="'startDate-' + question.AccountabilityLineId"
                            :customKey="question.AccountabilityLineId"
                            autofocus
                            :value="getDateValue(question.ResultaatAnswers, 'Startdatum')"
                          >
                          </v-input-date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="row grid-margin grid-padding">
                      <div class="col-md-3 stand-alone-accountability__categoryLabel">
                        Einddatum
                      </div>
                      <div class="col-md-6">
                        <div class="form-group__date">
                          <v-input-date-picker
                            ref="date"
                            type="date"
                            :name="'endDate-' + question.AccountabilityLineId"
                            :id="'endDate-' + question.AccountabilityLineId"
                            :customKey="question.AccountabilityLineId"
                            autofocus
                            :value="getDateValue(question.ResultaatAnswers, 'Einddatum')"
                          >
                          </v-input-date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="row grid-margin grid-padding">
                      <div class="col-xs-12 remark hide-msg" :id="'remark-' + question.AccountabilityLineId" >*Gelieve alle velden in te vullen. Einddatum mag niet eerder zijn dan de startdatum.</div>
                      <div class="col-xs-4">
                        <v-button type="submit" lg hollow >Volgende vraag</v-button>
                      </div>
                    </div>
                  </form>
                  <!-- File upload Question-->
                  <div class="row grid-margin grid-padding stand-alone-accountability__fileUpload" v-if="answer.TypeCode === 'FileUpload'">
                    <div class="form-group" v-show="question.ResultaatAnswers.length > 0" v-for="(dataFile, index) in question.ResultaatAnswers" :key="index">
                      <fieldset>
                        <legend>Geüploade bestanden</legend>
                        <img v-if="fileExtention(dataFile.Resultaat) === 'pdf'" src="@/static/img/pdf-icon.png">
                        <img v-else src="@/static/img/img-icon.svg">
                        <a>{{ dataFile.Resultaat }}</a>
                        <div class="stand-alone-accountability__fileUpload__date">Geüpload op {{ moment(dataFile.FileUploadedDate).format('DD-MM-YYYY') }}</div>
                      </fieldset>
                    </div>
                    <div class="col-xs-12">
                      <v-input-file-upload
                        :name="question.AccountabilityLineId"
                        :id="answer.AnswerId"
                        :uploadedFilesData="[]"
                        :allowedExtenstions="allowedFileExtenstions"
                        :extensionErrorMessage ="extensionErrorMessage"
                        dropAreaSecondaryMessage="(max. 2MB voor pdf en 5mb voor afbeelding; alleen .pdf, png, jpeg, jpg)"
                        @uploadSuccess="submitUploadedFiles"
                      >
                      </v-input-file-upload> 
                      <div class="stand-alone-accountability__fileUpload__errorMessage" v-if="showUploadFileErrorMessage">* Dit veld is verplicht.</div>
                    </div>
                  </div>
                  <v-warning-message v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId && answer.Opmerking" :message="answer.Opmerking" :html="true"></v-warning-message>
                </div>
              </fieldset>
              <!--Start DATE QUESTION-->
              <div class="form-group__date" v-if="showStartDate()">
                <v-input-date-picker
                  ref="startDate"
                  type="date"
                  name="startDate"
                  label="Startdatum therapie:"
                  autofocus
                  customDateRange
                  accountabiliyStartDate
                  @selected="handleStartDate"
                >
                </v-input-date-picker>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table stand-alone-accountability__signature" v-if="isLastAnswer && canSign" id="step2">
      <thead class="head">
        <tr>
          <th colspan="2">Handtekening</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="hasMultipleSignees">
          <td colspan="2">
            <v-select-group
            label="Beschikbare volmachtgevers"
            selectid="warranter"
            initselected=""
            @change="setSelectedSigneePpwRecId($event)"
            >
              <option value="">Selecteer volmachtgever</option>
              <option v-for="(signee, index) in signees" :key="index" :data-index="index" :initvalue="signee.ppwRecId" :value="signee.ppwRecId" >{{signee.name}}</option>
            </v-select-group>
          </td>
        </tr>
        <tr v-if="selectedSignee">
          <td>
            <prescriber-signature :userId="selectedSignee.userId" /><br /><br />
            <span v-if="selectedSignee.userId !== user.id">Volmachtgever: {{ selectedSignee.name }}</span>
          </td>
          <td>Door te klikken op de knop ondertekenen, signeert u deze machtiging met uw digitale handtekening.</td>
        </tr>
      </tbody>
    </table>
    <div class="row" id="step3">
      <div class="grid-align-start">
        <v-button md secondary nowrap class="save-accountability" :class="{ 'btn--disabled' : isSignButtonDisabled() }" @click.native.once="saveAccountability">
          <sync-loader v-if="isLoading"></sync-loader>
          <div v-else>ONDERTEKENEN</div>
        </v-button>
      </div>
      <div class="col grid-align-start">
        <a class="cancel-accountability" @click="cancelAccountability">Annuleren</a>
      </div>
      <div class="col-md-6 grid-align-end">
        <v-button link @click.native="openForwardModal"> <v-forward-icon class="icon-color-teal"></v-forward-icon>Doorsturen naar collega</v-button>
      </div>
    </div>
    <!-- Modal section -->
    <generic-modal v-if="fwAccountabilityPopUp">
      <template #header>
        {{forwardAccountabilityPopup.PopupTitle}}
      </template>
      <template #body>
        <p>{{forwardAccountabilityPopup.PopupText}}</p>
      </template>
      <template #footer>
        <router-link :to="'/patientdashboard'" class="btn btn--primary btn--md" >{{forwardAccountabilityPopup.PopupButton}}</router-link>
      </template>
    </generic-modal>
    <generic-modal v-if="illnessIdStatus">
      <template #header>
        Ondertekenen niet mogelijk
      </template>
      <template #body>
        <p>De vragenlijst is zodanig ingevuld dat hiervoor geen machtiging aangemaakt kan worden. Wijzig de vragenlijst of sluit de vragenlijst af.</p>
      </template>
      <template #footer>
        <v-button md hollow transparent @click.native="cancelAccountability()">Terug naar patiënt</v-button>
        <v-button md primary @click.native.prevent="closeIllnessPopUp()">Vragenlijst wijzigen</v-button>
      </template>
    </generic-modal>
    <generic-modal v-if="showPumpAssignPopUp">
      <template #header>
        Ondertekening succesvol.
      </template>
      <template #body>
        <p>Uw machtiging is toegevoegd aan het dashboard van de patiënt.
          <span v-if="pumpAssignment">U kunt nu een pomp toevoegen aan de machtiging.</span>
        </p>
      </template>
      <template #footer>
        <router-link :to="'/patientdashboard'" class="btn btn--hollow btn--transparent btn--md" >{{ forwardAccountabilityPopup.PopupButton }}</router-link>
        <v-button md primary @click.native.prevent="goToPumpAssign()" v-if="pumpAssignment">Naar pomp toevoegen</v-button>
      </template>
    </generic-modal>
  </section>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import store from '@/store'
import router from '@/router'
import { mapGetters, mapActions } from 'vuex'
import PrescriberSignature from '@/components/sections/prescriber/PrescriberSignature'
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup'
import VButton from '@/components/shared/Button.vue'
import VForwardModal from './ForwardModal'
import VForwardIcon from 'icons/ArrowRightBoldBox'
import { EventBus } from '@/components/shared/event-bus.js'
import VInputDatePicker from '@/components/shared/form/simple/InputDatePicker'
import moment from 'moment'
import VWarningMessage from '@/components/shared/WarningMessage'
import { BasicSelect } from 'vue-search-select'
import VInputFileUpload from '@/components/shared/form/simple/InputFileUpload'
import shared from '@/components/shared/shared'
import 'intro.js/minified/introjs.min.css'
import introJs from 'intro.js'
import { localDateToJson, stringToLocalDate } from '@/services/date.service'
import GenericModal from '@/components/shared/GenericModal'
import {
  shoppingCart$,
  addToShoppingCart,
  addIllnessBundleToShoppingCart,
  activePpwRecId$,
  currentUserIdentity$,
  getAccountabilityRootStatus,
  getSignees,
  invalidateLicenseOverviews$
} from '@/services';
import { router$ } from '@/router/router$';
import { map, filter, publishReplay, switchMap, refCount } from 'rxjs/operators';
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

export default {
  name: 'StandaloneAccountability',
  components: {
    VButton,
    VCheckboxGroup,
    VForwardIcon,
    VInputDatePicker,
    VWarningMessage,
    BasicSelect,
    GenericModal,
    VInputFileUpload,
    PrescriberSignature,
    SyncLoader
  },
  subscriptions () {
    const accountabilityId$ = router$.pipe(
      map(route => route && route.params.id),
      filter(accountabilityId => !!accountabilityId)
    );

    const accountability$ = accountabilityId$.pipe(
      switchMap(accountabilityId => this.loadAccountability(accountabilityId)),
      publishReplay(1),
      refCount()
    );

    const treatmentAreaId$ = accountability$.pipe(
      map(accountability => accountability.TreatmentAreaId)
    );

    const signees$ = treatmentAreaId$.pipe(
      switchMap(treatmentAreaId => getSignees(treatmentAreaId)),
      publishReplay(1),
      refCount()
    )

    return {
      user: currentUserIdentity$,
      accountabilityId: accountabilityId$,
      accountability: accountability$,
      treatmentAreaId: treatmentAreaId$,
      signees: signees$,
      shoppingCart: shoppingCart$,
      activePpwRecId: activePpwRecId$
    };
  },
  data () {
    return {
      pumpAssignment: null,
      searchLicenseText: 'Geen machtiging beschikbaar',
      startDate: null,
      illnessIdStatus: false,
      buttonDisableStatus: false,
      isTextChanged: false,
      currentAnswerId: 0,
      stringItem: '',
      WLZItem: {
        value: null,
        text: null
      },
      WLZArg: {
        WLZId: null
      },
      ZVZItem: {
        value: null,
        text: null
      },
      ZVZArg: {
        ZVZId: null
      },
      isRadioTextChanged: false,
      currentRadioAnswerId: 0,
      isOpenTextValidated: true,
      fwAccountabilityPopUp: false,
      intro: introJs(),
      showUploadFileErrorMessage: false,
      showPumpAssignPopUp: false,
      selectedSigneePpwRecId: "",
      isLoading: false,
      allowedFileExtenstions: ['pdf', 'jpg', 'jpeg', 'png'],
      extensionErrorMessage: 'Het geüploade document heeft niet de juiste extensie. U kunt alleen PDF, JPEG, JPG, of PNG documenten uploaden.'
    }
  },
  computed: {
    // VueJs store map getters to fetch store data
    ...mapGetters({
      patientGegevens: 'patient/getPatientGegevens',
      licenseWithTreatmentAreaName: 'accountability/getLicenseWithTreatmentAreaName',
      questions: 'accountability/getQuestions',
      isLastAnswer: 'accountability/getIsLastAnswer',
      isSingleAccountability: 'accountability/getIsSingleAccountability',
      isNewAccountability: 'accountability/getIsNewAccountability',
      isStartDate: 'accountability/getIsStartDate',
      isWLZ: 'accountability/getIsWLZ',
      isZVZ: 'accountability/getIsZVZ',
      WLZList: 'accountability/getWLZList',
      ZVZList: 'accountability/getZVZList',
      forwardAccountabilityPopup: 'accountability/getForwardAccountabilityPopup'
    }),
    canSign () {
      return this.signees && this.signees.length > 0;
    },
    hasMultipleSignees () {
      return this.signees && this.signees.length > 1;
    },
    hasSingleSignee () {
      return this.signees && this.signees.length === 1;
    },
    selectedSignee () {
      if (this.hasSingleSignee) {
        return this.signees[0];
      }
      else if (this.hasMultipleSignees) {
        return this.signees.find((v) => v.ppwRecId == this.selectedSigneePpwRecId);
      }

      return null;
    },
    isSignable () {
      return this.isLastAnswer && this.canSign && this.selectedSignee;
    }
  },
  async created () {
    // Dispatching server calls to fetch Patient and accountability questions details
    await store.dispatch('patient/getCurrentPatient')

    if (store.state.navigation.demo && store.state.navigation.demoActivated && store.state.navigation.demoFlow.createLicense) {
      setTimeout(() => {
        this.intro.setOptions({
          steps: [
            {element: '#step1', intro: 'Zodra je het juiste type machtiging hebt geselecteerd, beland je op de pagina met de vragenlijst. Vul deze vragen in op basis van de indicatie van de patiënt. Wees niet bang: Als je een antwoord wilt veranderen kan dat natuurlijk gewoon!', position: 'bottom-left-aligned'}
          ],
          exitOnEsc: false,
          exitOnOverlayClick: false,
          skipLabel: 'Overslaan',
          nextLabel: 'Volgende >',
          prevLabel: '< Terug',
          doneLabel: 'Okey, begrepen'
        })
        this.intro.start().onchange(function () {
        }).oncomplete(function () {
        })
        window.scrollTo(0, 0)
      }, 1500)
    }
  },
  destroyed () {
    store.commit('accountability/setIsLastAnswer', false)
    store.commit('accountability/setQuestions', {})
  },
  watch: {
    isLastAnswer (value) {
      const self = this
      if (value) {
        // Checking the illenss error pop up possibility after every question submit and last answer submit
        this.showIllnessPopUp()
        this.checkUploadFileStatus(self)
      }
      if (value && this.selectedSignee && this.canSign &&
      store.state.navigation.demo && store.state.navigation.demoActivated && store.state.navigation.demoFlow.createLicense) {
        setTimeout(() => {
          this.intro.setOptions({
            steps: [
              {element: '#step2', intro: 'Als je klaar bent met het invullen van de vragen, kan je de machtiging ondertekenen door op deze knop te drukken. Je ziet hier ook een afbeelding van de door jou gebruikte handtekening. Klik op de knop!', position: 'bottom-left-aligned'},
              {element: '#step3', intro: 'Click Ondertekenen!', position: 'bottom-left-aligned'}
            ],
            exitOnEsc: false,
            exitOnOverlayClick: false,
            skipLabel: 'Overslaan',
            nextLabel: 'Volgende >',
            prevLabel: '< Terug',
            doneLabel: 'Okey, begrepen'
          })
          this.intro.start().onchange(function () {
          }).oncomplete(function () {
            self.intro.exit()
            self.saveAccountability()
          })
        }, 1500)
      }
    }
  },
  methods: {
    async loadAccountability (accountabilityId) {
      // initialize accountability / questions
      var accountabilityRootStatus = await getAccountabilityRootStatus(accountabilityId);
      if(accountabilityRootStatus === null) {
        // todo: reset page (/s very acceptable: _we like happy flows_)
        return;
      }

      const response = await store.dispatch('accountability/getQuestions', this.accountabilityId);
      return response;
    },
    fileExtention: shared.fileExtention,
    onSelect (WLZItem) {
      this.WLZItem = WLZItem
      this.WLZArg.WLZId = WLZItem.value
      this.WLZArg.AccountabilityId = this.accountabilityId;
      store.dispatch('accountability/setWLZId', this.WLZArg)
    },
    onSelectZVZ (ZVZItem) {
      this.ZVZItem = ZVZItem
      this.ZVZArg.ZVZId = ZVZItem.value
      this.ZVZArg.AccountabilityId = this.accountabilityId;
      store.dispatch('accountability/setZVZId', this.ZVZArg)
    },
    ...mapActions({
      forwardAccountability: 'accountability/forwardAccountability'
    }),
    // Function to handle accountability radio type question answer
    checkRadioAnswer (e) {
      // Check whether radio open text is visible or not, if so hide the block
      let formDivId = 'form' + e.currentTarget.name
      let formDiv = document.getElementById(formDivId)
      if (formDiv) {
        formDiv.style.display = 'none'
      }
      let answerObject = {
        'AccountabilityLineId': e.currentTarget.name,
        'Resultaten': [{
          'AnswerId': document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id,
          'Resultaat': ' '
        }]
      }
      this.submitAnswers(answerObject)
    },
    ChangeText (event, result, accountabilityLineId) {
      let answerId = event
      let answerText = document.getElementById(answerId) ? document.getElementById(answerId).value.trimEnd() : ''
      this.currentAnswerId = answerId
      let divid = 'div' + accountabilityLineId
      let divelement = document.getElementById(divid)
      if (result !== answerText) {
        this.isTextChanged = true
        if (divelement) {
          divelement.style.display = 'block'
        }
        this.buttonDisableStatus = true
      } else {
        this.buttonDisableStatus = false
        this.isTextChanged = false
        if (divelement) {
          divelement.style.display = 'none'
        }
      }
    },
    ChangeRadioText (event, result, accountabilityLineId) {
      let answerId = event
      let answerText = document.getElementById(answerId) ? document.getElementById(answerId).value.trimEnd() : ''
      this.currentRadioAnswerId = answerId.replace('txt', '')
      let divid = 'div' + accountabilityLineId
      let divelement = document.getElementById(divid)
      if (result !== answerText) {
        this.isRadioTextChanged = true
        this.buttonDisableStatus = true
        if (divelement) {
          divelement.style.display = 'block'
        }
      } else {
        this.isRadioTextChanged = false
        this.buttonDisableStatus = false
        if (divelement) {
          divelement.style.display = 'none'
        }
      }
    },
    // Function to handle accountability select type question answer
    checkSelectAnswer (e) {
      let answerObject = {
        'AccountabilityLineId': e.currentTarget.name,
        'Resultaten': [{
          'AnswerId': e.currentTarget.options[e.currentTarget.selectedIndex].dataset.answerid,
          'Resultaat': '',
          'AnswerListItemId': e.currentTarget.options[e.currentTarget.selectedIndex].value
        }]
      }
      this.submitAnswers(answerObject)
    },
    // Function to handle accountability submit type question answer
    submitTypeQuestionOpen (e) {
      e.preventDefault()
      let answerId = e.currentTarget.elements[0].id
      answerId = answerId.replace('txt', '')
      let divid = 'div' + e.currentTarget.name
      let divelement = document.getElementById(divid)
      if (divelement) {
        divelement.style.display = 'none'
      }
      if (this.isTextChanged === true) {
        this.isTextChanged = false
        this.buttonDisableStatus = false
      }
      if (this.isRadioTextChanged === true) {
        this.isRadioTextChanged = false
        this.buttonDisableStatus = false
      }
      let answerObject = {
        'AccountabilityLineId': e.currentTarget.name,
        'Resultaten': [{
          'AnswerId': answerId,
          'Resultaat': e.currentTarget.elements[0].value
        }]
      }
      this.submitAnswers(answerObject)
    },
    // Function to handle accountability check box type question answers
    submitCheckbox (e, answer) {
      e.preventDefault()
      let result = []
      for (let i = 0; i < e.currentTarget.elements.length - 1; i++) {
        if (e.currentTarget.elements[i].value === 'true') {
          result.push({
            'AnswerListItemId': e.currentTarget.elements[i].id,
            'Resultaat': e.currentTarget.elements[i].value,
            'AnswerId': answer.AnswerId
          })
        }
      }
      let openCheckbox = answer.AntwoordLijst.filter(opencheck => opencheck.IsOpen)
      if (result.length > 0) {
        // Check whether text box option selected or not, if so store the text box value to the result
        if (openCheckbox.length > 0) {
          for (let j = 0; j < result.length; j++) {
            result[j].AnswerListItemText = document.getElementById('text' + result[j].AnswerListItemId).value
          }
        }
        // If the question type is checkbox with text get all the input value for each option
        if (answer.TypeCode === 'CheckboxWithTextbox') {
          for (let j = 0; j < result.length; j++) {
            result[j].AnswerListItemText = document.getElementById('text' + result[j].AnswerListItemId).value
          }
        }
        $('#remark-' + e.currentTarget.name).hide()
        let answerObject = {
          'AccountabilityLineId': e.currentTarget.name,
          'Resultaten': result
        }
        this.submitAnswers(answerObject)
      } else {
        $('#remark-' + e.currentTarget.name).show()
      }
    },
    // Function to send user answers to the server and get the next question
    async submitAnswers (answerObject) {
      this.buttonDisableStatus = false
      answerObject.ForProductSelection = false
      await store.dispatch('accountability/setAnswer', answerObject)
      await store.dispatch('accountability/getQuestions', this.accountabilityId)
      await this.scrollToBottom()
    },
    // Function to cancel the accountability and redirect user to the patient dashboard
    cancelAccountability () {
      store.dispatch('accountability/cancelAccountabilityForm', this.accountabilityId).then(() => {
        router.push('/patientdashboard')
      })
    },
    // Function to save the accoutability
    saveAccountability () {
      this.isLoading = true
      let isBlock = false
      for (let i = 0; i < this.questions.length; i++) {
        let lineId = this.questions[i].AccountabilityLineId
        let divid = 'div' + lineId
        let divelement = document.getElementById(divid)
        if (divelement && divelement.style.display === 'block') {
          isBlock = true
          this.scrollToTop()
          return
        }
      }
      if (isBlock === false) {
        if (!this.startDate) {
          this.startDate = new Date()
          this.startDate = moment(this.startDate).format('DD-MM-YYYY')
        }

        const startDate = stringToLocalDate(this.startDate)
        const startDateJson = localDateToJson(startDate)

        const accountabilityDetails = {
          startDate: startDateJson,
          accountabilityId: this.accountabilityId,
          signeePpwRecId: this.selectedSignee.ppwRecId
        }

        store.dispatch('accountability/saveStandAloneAccountability', accountabilityDetails).then((response) => {
          if (store.state.navigation.siteCode === 'MRT') {
            axios.get('License/GetAccountabilityOrderDetails?AccountabilityId=' + this.accountabilityId).then((orderDetails) => {
              let gotoCheckoutPage = false
              let illnessBundleIds = orderDetails.data.AccountabilityOrderDetails.IllnessBundleIds
              let productIds = orderDetails.data.AccountabilityOrderDetails.ProductIds
              for (let i=0; i < illnessBundleIds.length; i++) {
                addIllnessBundleToShoppingCart(this.shoppingCart, illnessBundleIds[i]).then((response) => {
                  store.commit('cart/setCartOpenStatus', false);
                  this.shoppingCart.items.forEach((item) => {
                    this.$gtm.trackEvent({
                      event: 'ButtonClick',
                      event_category: 'Product cart',
                      event_action: 'Bestellen',
                      event_label: `${item.productId} ${item.productTitle}`,
                      event_value: String(item.quantity)
                    });
                  });
                })
                gotoCheckoutPage = true
              }
              for (let j=0; j < productIds.length; j++) {
                addToShoppingCart(this.shoppingCart, productIds[j], 1, this.activePpwRecId)
                gotoCheckoutPage = true
              }
              if (gotoCheckoutPage === true) {
                router.push('/bestellijst')
                return
              }
            })
          }
          if (this.canSign && this.selectedSignee && store.state.navigation.demo && store.state.navigation.demoActivated && store.state.navigation.demoFlow.createLicense) {
            store.commit('navigation/setDemoFlowStatus', {key: 'createLicense', value: false})
            store.commit('navigation/setDemoFlowStatus', {key: 'showLicense', value: true})
            router.push('/patientdashboard')
          }
          if (store.state.navigation.siteCode === 'MIF') {
            this.pumpAssignment = response.data && response.data.pumpAssignment

            invalidateLicenseOverviews$()
            this.isLoading = false
            this.showPumpAssignPopUp = true
          } else {
            router.push('/machtigingondertekend')
          }
        })
      } else {
        this.scrollToTop()
      }
    },
    goToPumpAssign () {
      router.push('/pumpassignment/verantwoording/' + this.pumpAssignment.licenseId)
    },
    // Function to get the checbox status based on the API response data
    getCheckboxStatus (resultArray, checkbox, answer) {
      let state = false
      for (let i = 0; i < resultArray.length; i++) {
        if (resultArray[i].AnswerListItemId === checkbox.AnswerListItemId) {
          state = true
          setTimeout(() => {
            this.change(true, checkbox, answer.AnswerId, answer.TypeCode)
          }, 1000)
        }
      }
      return state
    },
    // Function to forward an accountability to other prescriber of the same department
    async openForwardModal () {
      new Promise((resolve, reject) => {
        EventBus.$emit('prompt', {
          title: 'Machtiging doorsturen',
          message: 'Naar welke collega wilt u de machtiging doorsturen?',
          confirmButton: 'Doorsturen',
          component: VForwardModal,
          resolve,
          reject
        })
      })
      .then((select) => {
        this.forwardAccountability({
          accountabilityId: this.accountabilityId,
          ppwRecId: select.colleagueSelected.ppwRecId,
          comment: select.comment
        }).then(() => {
          this.fwAccountabilityPopUp = true
        }).catch(() => {
          EventBus.$emit('alert', { type: 3, message: 'Uw conceptaanvraag is mislukt.' })
        })
      })
      .catch(() => {})
    },
    // Function to handle date type question answer
    handleDateAnswer (date, answerId, lineId) {
      let answerObject = {
        'AccountabilityLineId': lineId,
        'ForProductSelection': false,
        'Resultaten': [{
          'AnswerId': answerId,
          'Resultaat': date
        }]
      }
      this.submitAnswers(answerObject)
    },
    // Function to handle start date value
    handleStartDate (date) {
      this.startDate = date
    },
    // Function to convert API response date string to required format for datePicker
    getDateValue (responseResult, key) {
      if (key !== 'Resultaat' && responseResult.length > 0 && responseResult[0][key]) {
        let temp = moment(responseResult[0][key]).format('DD-MM-YYYY')
        temp = temp.split('-')
        return temp[1] + '/' + temp[0] + '/' + temp[2]
      }
      if (responseResult.length > 0 && responseResult[0][key]) {
        let temp = responseResult[0][key]
        temp = temp.split('-')
        return temp[1] + '/' + temp[0] + '/' + temp[2]
      }
      return ''
    },
    // Function to handle PersonalAccountabilityProductGroup2 type question
    submitPersonalAccountabilityProductGroup2 (event) {
      event.preventDefault()
      let ProductGroupId = $('#selectProduct-' + event.target.name).find(':selected').val()
      let Aantal = $('#Aantal-' + event.target.name).val()
      let PeriodId = $('#selectPeriod-' + event.target.name).find(':selected').val()
      if (!ProductGroupId ||
      !Aantal ||
      !PeriodId) {
        $('#remark-' + event.target.name).show()
        return
      }
      $('#remark-' + event.target.name).hide()
      let answerObject = {
        'AccountabilityLineId': parseInt(event.target.name),
        'ForProductSelection': false,
        'Resultaten': [{
          'AnswerId': event.target.id,
          'Resultaat': '',
          'AnswerListItemId': '',
          'ProductGroupId': ProductGroupId,
          'Aantal': Aantal,
          'PeriodId': PeriodId
        }]
      }
      this.submitAnswers(answerObject)
    },
    // Function to handle PersonalAccountabilityProductGroup3 type question
    submitPersonalAccountabilityProductGroup3 (event) {
      event.preventDefault()
      let ProductGroupId = $('#selectProduct-' + event.target.name).find(':selected').val()
      let Aantal = $('#Aantal-' + event.target.name).val()
      let PeriodId = $('#selectPeriod-' + event.target.name).find(':selected').val()
      let Startdatum = $('#startDate-' + event.target.name).val()
      let Einddatum = $('#endDate-' + event.target.name).val()

      if (!ProductGroupId ||
      !Aantal ||
      !PeriodId ||
      !Startdatum ||
      !Einddatum) {
        $('#remark-' + event.target.name).show()
        return
      }
      if (!this.compareTwoDates(Startdatum, Einddatum)) {
        $('#remark-' + event.target.name).show()
        return
      }

      const startDate = stringToLocalDate(Startdatum)
      const startDateJson = localDateToJson(startDate)

      const endDate = stringToLocalDate(Einddatum)
      const endDateJson = localDateToJson(endDate)

      $('#remark-' + event.target.name).hide()
      let answerObject = {
        'AccountabilityLineId': parseInt(event.target.name),
        'ForProductSelection': false,
        'Resultaten': [{
          'AnswerId': event.target.id,
          'Resultaat': '',
          'AnswerListItemId': '',
          'ProductGroupId': ProductGroupId,
          'Aantal': Aantal,
          'PeriodId': PeriodId,
          'Startdatum': startDateJson,
          'Einddatum': endDateJson
        }]
      }
      this.submitAnswers(answerObject)
    },
    // Function to compare two string dates in which end date is either earliar to start date or not
    compareTwoDates (startDate, endDate) {
      let startDateRequiredFormat = startDate.split('-')
      startDateRequiredFormat = startDateRequiredFormat[2] + '/' + startDateRequiredFormat[1] + '/' + startDateRequiredFormat[0]
      let endDateRequiredFormat = endDate.split('-')
      endDateRequiredFormat = endDateRequiredFormat[2] + '/' + endDateRequiredFormat[1] + '/' + endDateRequiredFormat[0]
      return endDateRequiredFormat > startDateRequiredFormat
    },
    // Function to scroll to the bottom of the page
    async scrollToBottom () {
      $('html, body').animate({scrollTop: $(document).height()}, 'slow')
    },
    async scrollToTop () {
      $('html, body').animate({scrollTop: 0}, 'slow')
    },
    // Function to show start date input field
    showStartDate () {
      return this.isLastAnswer && this.isStartDate
    },
    // Function to enable/disable the save button
    isSignButtonDisabled () {
      return this.buttonDisableStatus || !this.isSignable
    },
    // Function to show illness related pop up
    showIllnessPopUp () {
      let count = 0
      if (this.isLastAnswer) {
        for (let i = 0; i < this.questions.length; i++) {
          for (let j = 0; j < this.questions[i].ResultaatAnswers.length; j++) {
            if (this.questions[i].ResultaatAnswers[j].HasIllness) {
              // If atleast one question had illness id allowing to sign the accountability
              count = count + 1
              this.illnessIdStatus = false
              this.buttonDisableStatus = false
              return
            }
          }
        }
      }
      if (count === 0) {
        this.illnessIdStatus = true
        this.buttonDisableStatus = true
      }
    },
    // Function to close the illeness related pop up
    closeIllnessPopUp () {
      this.illnessIdStatus = false
    },
    input (id, value) {
      id = id.replace('txt', '')
      let btnId = '#' + id + 'btn'
      if (value && value !== '') {
        $(btnId).removeClass('btn--disabled')
      } else {
        $(btnId).addClass('btn--disabled')
      }
    },
    inputCheckBox (id, value, nextBtnId) {
      let btnId = '#' + nextBtnId + 'btn'
      if (value && value !== '') {
        $(btnId).removeClass('btn--disabled')
      } else {
        $(btnId).addClass('btn--disabled')
      }
    },
    getNextButtonStatus (id) {
      if (id) {
        let value = document.getElementById(id) ? document.getElementById(id).value : ''
        return value === undefined || value === '' || value === null
      }
      return true
    },
    getNextRadioButtonStatus (id) {
      if (id) {
        let txtId = id + 'txt'
        let value = document.getElementById(txtId) ? document.getElementById(txtId).value : ''
        return value === undefined || value === '' || value === null
      }
      return true
    },
    // Function to handle accountability radio standard type question answer
    checkedRadioAnswerStandard (radioId, nameId) {
      let radioButton = document.getElementById(radioId)
      let formDivId = 'form' + nameId
      let formDiv = document.getElementById(formDivId)
      if (radioButton) {
        formDiv.style.display = radioButton.checked ? 'block' : 'none'
        let divid = 'div' + nameId
        let divelement = document.getElementById(divid)
        if (divelement) {
          divelement.style.display = 'none'
        }
      }
    },
    // Function to set/unset checkbox text box and the next question button status
    change (active, checkbox, nextBtnId, answerType) {
      let formDivId = 'form' + checkbox.AnswerListItemId
      let formDiv = document.getElementById(formDivId)
      if (formDiv) {
        let btnId = '#' + nextBtnId + 'btn'
        if ((answerType === 'CheckboxWithTextbox' || checkbox.IsOpen) && active) {
          formDiv.style.display = 'block'
          $(btnId).addClass('btn--disabled')
        } else {
          formDiv.style.display = 'none'
          $(btnId).removeClass('btn--disabled')
        }
      }
    },
    /**
     * @function getOpenTextItemId
     * @description Function to get the open text check box details from the list
     */
    getOpenTextItemId (checkboxAnswerList) {
      let answerListId = ''
      for (let i = 0; i < checkboxAnswerList.length; i++) {
        if (checkboxAnswerList[i].IsOpen) {
          answerListId = checkboxAnswerList[i].AnswerListItemId
          break
        }
      }
      return answerListId
    },
    /**
     * @function checkCheckBoxTextAns
     * @description Function to get the checkbox text ans from the answers result
     */
    checkCheckBoxTextAns (ansList, listId, type) {
      let status = false
      let value = ''
      for (let i = 0; i < ansList.length; i++) {
        if (listId === ansList[i].AnswerListItemId) {
          status = true
          value = ansList[i].AnswerListItemText
        }
      }
      if (type === 'status') {
        return status
      }
      return value
    },
    /**
     * @function checkRadioStatus
     * @description Function to load the text box ans for the radio button on edit flow
     */
    checkRadioStatus (resultList, ansId, lineId) {
      let txtId = ansId + 'txt'
      let value = document.getElementById(txtId) ? document.getElementById(txtId).value.trimEnd() : ''
      let status = false
      let divid = 'div' + lineId
      let divelement = document.getElementById(divid)
      if (resultList.length > 0 && resultList[0].AnswerId === ansId) {
        if (resultList[0].AnswerId === ansId) {
          status = true
          this.checkedRadioAnswerStandard(ansId, lineId)
          if (divelement && value === '') {
            divelement.style.display = 'block'
          }
          if (divelement && resultList[0].Resultaat === value) {
            divelement.style.display = 'none'
          }
          if (divelement && resultList[0].Resultaat !== value) {
            divelement.style.display = 'block'
          }
        }
      }
      return status
    },
    submitUploadedFiles (fmData, requiredDetails) {
      store.dispatch('accountability/saveAccountabilityUpload', fmData).then((response) => {
        if (response && response.data) {
          this.submitAnswers({
            'AccountabilityLineId': requiredDetails.name,
            'Resultaten': [{
              'AnswerId': requiredDetails.id,
              'Resultaat': response.data.FileName,
              'Pdf': response.data.Pdf
            }]
          })
        }
      })
    },
    // Function to convert datetime to required specific format
    moment (...args) {
      return moment(...args)
    },
    checkUploadFileStatus (self) {
      let uploadFileStatus = false
      for (let i = 0; i < self.questions.length; i++) {
        for (let j = 0; j < self.questions[i].Antwoorden.length; j++) {
          if (self.questions[i].Antwoorden[j].TypeCode === 'FileUpload' && self.questions[i].ResultaatAnswers.length === 0) {
            uploadFileStatus = true
            break
          }
        }
        if(uploadFileStatus) {
          break
        }
      }
      if (uploadFileStatus) {
        store.commit('accountability/setIsLastAnswer', false)
        this.showUploadFileErrorMessage = true
      } else {
        this.showUploadFileErrorMessage = false
      }
    },
    setSelectedSigneePpwRecId (event) {
      this.selectedSigneePpwRecId = event.currentTarget.value
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-animation-enter-active, .card-animation-leave-active {
      transition: all 0.5s ease;
  }
  .card-animation-enter, .card-animation-leave-to {
      opacity: 0;
    transform: translateX(30px);
  }
  .stand-alone-accountability {
    .margin-bottom {
      margin-bottom: 15px;
    }
    &__categoryLabel {
      padding-top: 30px;
      font-weight: 500;
    }
    &__popup {
      font-size: 20px !important;
      font-weight: 500 !important;
    }
    &__backToCatalog {
      display: flex;
      justify-content: center !important;
    }
    &__signature {
      img {
        border: solid 2px $grayish-med-light;
        vertical-align: text-top;
        max-width: 350px !important;
        height: auto;
        width: 100%;
      }
      /deep/
      .form-group {
        padding: 0px;
        label {
          font-weight: 900;
          color: $gray-dark;
          position: initial;
          transform: none !important;
          line-height: normal;
          background: transparent;
        }
        &__icon {
          margin: 25px 10px 0 0;
        }
        .form-group__details {
          &:after {
            content: none;
          }
          &:before {
            content: none;
          }
        }
      }
    }
    &__fileUpload {
      .form-group {
        padding: 0px;
      }
      fieldset {
        padding: 6px 0 10px !important;
      }
      a {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.87);
        margin: 0px;
        pointer-events: none;
      }
      img {
        vertical-align: middle;
        height: 32px;
      }
      legend {
        margin: 10px 0px 10px 0px;
      }
      /deep/ .uploadBox {
        padding: 0px;
      }
      &__date {
        margin: 10px 0px 10px 5px !important;
        color: $gray;
      }
      &__errorMessage {
        color: $red;
      }
    }
    .hide-msg {
      display: none;
    }
    .save-accountability {
      color: $white;
    }
    .cancel-accountability {
      color: $cyan-med-dark;
      text-decoration: underline !important;
      line-height: 1.5rem;
      text-decoration: none;
      font-weight: 300;
      display: block;
      cursor: pointer;
      margin: .5rem .5rem .5rem 1.5rem;
    }
    // Width of each table column
    $table-columns: (
      1: 40px,
      2: 30%,
      3: 30%,
      4: 15%,
      5: 15%,
      6: 50px
    ) !default;
    table {
      table-layout: auto !important;
      width: 100%;
      max-width: 100%;
      border-collapse: collapse;
      margin-bottom: 20px;
      text-align: left;

      // Generate classes for each column and assign width
      @each $table-column-key, $table-column-value in $table-columns {
        .table-col-#{$table-column-key} {
          width: $table-column-value
        }
      }

      > thead > tr {
        background-color: rgba(0, 0, 0, 0.03);

        > td, > th {
          vertical-align: baseline;
          text-align: left;
          padding: 10px;
          color: $gray-darkest;
          font-size: type-scale(0);
          line-height: line-height(0);
          font-weight: normal;
        }
      }

      > tbody {
        background: $white;

        > tr:first-child {

          > td, > th {
            vertical-align: baseline;
            text-align: left;
            padding: 16px 10px;
          }
        }

        > tr:last-child td {
          padding: 10px 10px 16px;
        }

        &.action-required {
          background-color: $pink;
        }
      }

      .hidden {
        display: none;
      }
    }
    .startDateCalender {
      margin-top: 45px !important;
    }
    form.openquestion {
      padding-bottom: 16px;
    }
    fieldset {
      margin: 0;
      padding: 6px 0 20px;
      border: 0;

      legend {
        font-weight: bold;
        line-height: 1.4;
        color: $gray-darkest;
        font-size: inherit;
      }

      div {
        margin: 0;
      }

      form {
        width: 100%;
      }
    }
    .form-group #menu-down-icon {
      fill:$aqua ;
    }
    .remark {
      font-size: .8rem;
      color: $red;
      padding: 0 0 1rem calc(20px + .5rem);

    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.25s ease-out, bottom 0.25s ease-out;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
      bottom: -100px
    }
    .icon-color-teal {
      padding-right: 6px;
      fill: $teal-darkest;
    }
    .bold {
      font-weight: bold;
      margin-bottom: 10px;
    }
    .mb {
      margin-bottom: 30px;
    }
    &__error {
      font-size: $form-group-details-font-size;
      min-height: 26px;
      padding-top: 10px;
      color: $red;
      transition: $form-group-error-transition;
    }
    /deep/
    .form-group-simple input {
      margin-right: 10px;
    }
  .groupText {
    /deep/
    .form-group-simple {
      margin-top: 15px;
    }
  }
  .form-group {
    &__date  {
    .form-group-simple input {
      width: 100%;
    }
    }
  }
  .btn {
    margin-bottom: 10px;
  }
}
.details {
  background: none;
}
</style>
